import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap';

import { SharedModule } from '../shared/shared.module';

import { BondsmanDetailComponent } from './bondsman-detail.component';
import { BondsmanComponent } from './bondsman.component';
import { LicenseeInformationComponent } from './licensee-information/licensee-information.component';
import { LicenseeStatusComponent } from './licensee-status/licensee-status.component';
import { BondForfeituresComponent } from './bond-forfeitures/bond-forfeitures.component';
import { BondsmanSearchResultsTableComponent } from './bondsman-search-results-table/bondsman-search-results-table.component';
import { BondsmanSearchService } from './bondsman-search.service';
import { BondsmanDirective } from './bondsman.directive';
import { CaseViewModule } from '../case-view/case-view.module';

@NgModule({
  imports: [
    AccordionModule,
    AlertModule,
    BsDropdownModule,
    PopoverModule,
    BsDatepickerModule,
    CommonModule,
    MultiselectDropdownModule,
    ReactiveFormsModule,
    SharedModule,
    CaseViewModule
  ],
  declarations: [
    BondsmanComponent,
    BondsmanDetailComponent,
    LicenseeInformationComponent,
    LicenseeStatusComponent,
    BondForfeituresComponent,
    BondsmanSearchResultsTableComponent,
    BondsmanDirective
  ],
  providers: [
    DatePipe,
    BondsmanSearchService
  ]
})
export class BondsmanModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman.module.ts